import { render, staticRenderFns } from "./TimeBiggestPurchaseChart.vue?vue&type=template&id=58da3c08&scoped=true"
import script from "./TimeBiggestPurchaseChart.vue?vue&type=script&lang=js"
export * from "./TimeBiggestPurchaseChart.vue?vue&type=script&lang=js"
import style0 from "./TimeBiggestPurchaseChart.vue?vue&type=style&index=0&id=58da3c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da3c08",
  null
  
)

export default component.exports